<template>
  <v-row>
    <v-col cols="12" class="mt-4">
      <v-sheet
        class="mt-8"
        outlined>
        <v-row class="pa-4">
          <v-col cols="12">
            <h3>Emprendedores:</h3>
          </v-col>

          <v-col cols="12" xl="3" md="3" sm="12">
            <v-sheet
              outlined
              :elevation="(type_postulation_id=='all') ? 10 : 0"
              :color="(type_postulation_id=='all') ? 'cyan lighten-5' : 'none'"
              class="elevated-sheet"
              @click="selectEntrepreneurshipsType('all')"
              height="160px"
              style="cursor:pointer;">
              <v-row class="pa-2">
                <v-col cols="6">
                  <v-img 
                    alt="UNL" 
                    contain
                    height="80px"
                    :src="require('@/assets/img/entrepreneur.png')">
                  </v-img>
                </v-col>
                
                <v-col cols="6" class="d-flex align-center justify-center">
                  <h1 class="text-center">{{ entrepreneurial_count }}</h1>
                </v-col>

                <v-col cols="12">
                  <h4 class="text-center">Emprendedores</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>

          <v-col cols="12" xl="3" md="3" sm="12">
            <v-sheet
              outlined
              :elevation="(type_postulation_id==1) ? 10 : 0"
              :color="(type_postulation_id==1) ? 'cyan lighten-5' : 'none'"
              class="elevated-sheet"
              height="160px"
              @click="selectEntrepreneurshipsType('idea-project')"
              style="cursor:pointer;">
              <v-row class="pa-2">
                
                <v-col cols="12"  
                  class="d-flex align-center justify-center"
                  style="height: 105px;">
                  <h1 class="text-center">{{ entrepreneurial_ip_count }}</h1>
                </v-col>

                <v-col cols="12">
                  <h4 class="text-center">Emprendedores Idea Proyecto</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>

          <v-col cols="12" xl="3" md="3" sm="12">
            <v-sheet
              outlined
              :elevation="(type_postulation_id==2) ? 10 : 0"
              :color="(type_postulation_id==2) ? 'cyan lighten-5' : 'none'"
              class="elevated-sheet"
              @click="selectEntrepreneurshipsType('idea-project-school')"
              style="cursor:pointer;"
              height="160px">
              <v-row class="pa-2">

                <v-col cols="12" 
                  class="d-flex align-center justify-center"
                  style="height: 105px;">
                  <h1 class="text-center">{{ entrepreneurial_ip_school_count }}</h1>
                </v-col>

                <v-col cols="12">
                  <h4 class="text-center">Emprendedores IP Escuelas</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>

          <v-col cols="12" xl="3" md="3" sm="12">
            <v-sheet
              outlined
              :elevation="(type_postulation_id==3) ? 10 : 0"
              :color="(type_postulation_id==3) ? 'cyan lighten-5' : 'none'"
              class="elevated-sheet"
              @click="selectEntrepreneurshipsType('mdn')"
              style="cursor:pointer;"
              height="160px">
              <v-row class="pa-2">
                
                <v-col cols="12" 
                  class="d-flex align-center justify-center"
                  style="height: 105px;">
                  <h1 class="text-center">{{ entrepreneurial_mdn_count }}</h1>
                </v-col>

                <v-col cols="12">
                  <h4 class="text-center">Emprendedores MDN</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        color="error">
        <p class="white--text d-flex align-center justify-center pt-2 pl-2 pr-2">
          ¡ATENCIÓN!, los siguientes indicadores corresponden a emprendedores registrados, 
          es decir, aquellos que completaron su perfíl.  
        </p>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="6" md="6" sm="12">
      <v-sheet
        height="500"
        class="d-flex align-center ">

        <v-col cols="12">
            
          <v-sheet
            outlined
            class="mt-4 mb-8 pt-8 pb-8">
            <v-row>
              
              <v-col cols="12" class="d-flex align-center justify-center">
                <h2 class="text-center">{{ entrepreneurial_register_count }}</h2>
              </v-col>

              <v-col cols="12">
                <h4 class="text-center">Registrados</h4>
              </v-col>
            </v-row>
          </v-sheet>
          
          <v-sheet
            outlined
            class="mt-4 mb-8 pt-8 pb-8">
            <v-row>
              
              <v-col cols="12" class="d-flex align-center justify-center">
                <h2 class="text-center">{{ entrepreneurial_no_register_count }}</h2>
              </v-col>

              <v-col cols="12">
                <h4 class="text-center">No registrados</h4>
              </v-col>
            </v-row>
          </v-sheet>
              
        </v-col>

      </v-sheet>
    </v-col>

    <v-col cols="12" xl="6" md="6" sm="12">
      <v-sheet
        height="500">
        <apexchart
          class="pt-8"
          type="pie" 
          height="460"
          :options="entrepreneurial_register_series_pie_options" 
          :series="entrepreneurial_register_series[0].data">
        </apexchart>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Emprendedores por País:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="bar" 
              height="400" 
              :options="entrepreneurial_countries_chart_options" 
              :series="entrepreneurial_countries_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Emprendedores de Argentina:</h4>
          </v-col>
  
          <v-col cols="12">
            <apexchart 
              type="bar" 
              height="400" 
              :options="entrepreneurials_provincias_chart_options" 
              :series="entrepreneurials_provincias_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'entrepreneurialIndicators',

    props:['edition_id'],
    data: () => ({
      loading:true,

      data: null,

      type_postulation_id:'all',
      
      entrepreneurial_count:0,
      entrepreneurial_ip_count:0,
      entrepreneurial_ip_school_count:0,
      entrepreneurial_mdn_count:0,

      entrepreneurial_register_count:0,
      entrepreneurial_no_register_count:0,
      entrepreneurial_register_series: [
        {
          name: 'Emprendedores',
          data: []
        }
      ],
      entrepreneurial_register_series_pie_options: {
        chart: {
          type: "pie",
        },
        labels: [],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
        },
      },

      //EMPRENDEDORES POR PAIS
      entrepreneurial_countries_count:0,
      entrepreneurial_countries_chart_options: {
        name: 'Paises',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      entrepreneurial_countries_series: [
        {
          name: 'Emprendedores',
          data: []
        }
      ],

      //EMPRENDEDORES POR PROVINCIA
      entrepreneurials_provincias_count:0,
      entrepreneurials_provincias_chart_options: {
        name: 'Provincias',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      entrepreneurials_provincias_series: [
        {
          name: 'Emprendedores',
          data: []
        }
      ],


    }),
    methods:{
      async getEntrepreneurials()
      {
        await axios.get('admin/indicators/entrepreneurials/'+this.edition_id).then(response =>{
          this.entrepreneurial_count = response.data.data.entrepreneurial_count
          this.entrepreneurial_ip_count = response.data.data.entrepreneurial_ip_count
          this.entrepreneurial_ip_school_count = response.data.data.entrepreneurial_ip_school_count
          this.entrepreneurial_mdn_count = response.data.data.entrepreneurial_mdn_count
          this.show=true
        }).catch(error => {
          console.log(error);
        })
      },

      selectEntrepreneurshipsType(type_postulation){
        switch (type_postulation) {
          case 'all':
            this.type_postulation_id='all';
            break;
          case 'idea-project':
            this.type_postulation_id=1;
            break;
          case 'idea-project-school':
            this.type_postulation_id=2;
            break;
          case 'mdn':
            this.type_postulation_id=3;
            break;
          default:
            this.type_postulation_id='all';
            break;
        }
        this.updateData()
      },

      async updateData(){
        this.loading = true
        Promise.all([
          this.getEntrepreneurialsType(),
          this.getEntrepreneurialsCountries(),
          this.getEntrepreneurialsCountriesArgentina()
        ]).then(() => {
          this.loading = false
        }).catch((error) => {
          console.log(error)
        });
      },

      async getEntrepreneurialsType()
      {
        this.entrepreneurial_register_series_pie_options.labels = []
        this.entrepreneurial_register_series[0].data = []
        
        await axios.get('admin/indicators/entrepreneurials/'+this.edition_id+'/'+this.type_postulation_id ).then(response =>{
          
          this.data = response.data.data
          this.entrepreneurial_register_count = response.data.data.entrepreneurial_register_count
          this.entrepreneurial_no_register_count = response.data.data.entrepreneurial_no_register_count


          this.entrepreneurial_register_series_pie_options.labels.push( 'Emprendedores registrados' )
          this.entrepreneurial_register_series[0].data.push( this.entrepreneurial_register_count )

          this.entrepreneurial_register_series_pie_options.labels.push( 'Emprendedores no registrados' )
          this.entrepreneurial_register_series[0].data.push( this.entrepreneurial_no_register_count )

        }).catch(error => {
          console.log(error);
        })
      },

      async getEntrepreneurialsCountries()
      {
        this.entrepreneurial_countries_chart_options.xaxis.categories = []
        this.entrepreneurial_countries_series[0].data = []

        let url = 'admin/indicators/entrepreneurials/'+this.edition_id+'/'+this.type_postulation_id+'/countries'

        await axios.get(url).then(response =>{
          this.entrepreneurial_countries_count = response.data.data.entrepreneurials_countries_count

          this.entrepreneurial_countries_count.forEach(element => {

          this.entrepreneurial_countries_chart_options.xaxis.categories.push( Object.values(element)[1] )
          this.entrepreneurial_countries_series[0].data.push( Object.values(element)[2] )

          });
        }).catch(error => {
          console.log(error);
        })
      },
      
      async getEntrepreneurialsCountriesArgentina()
      {
        this.entrepreneurials_provincias_chart_options.xaxis.categories = []
        this.entrepreneurials_provincias_series[0].data = []

        let url = 'admin/indicators/entrepreneurials/'+this.edition_id+'/'+this.type_postulation_id+'/provincias'

        await axios.get(url).then(response =>{
          this.entrepreneurials_provincias_count = response.data.data.entrepreneurials_provincias_count

          this.entrepreneurials_provincias_count.forEach(element => {

            this.entrepreneurials_provincias_chart_options.xaxis.categories.push( Object.values(element)[1] )
            this.entrepreneurials_provincias_series[0].data.push( Object.values(element)[2] )
          
          });

        }).catch(error => {
          console.log(error);
        })
      },
    },
    created(){
      Promise.all([
        this.getEntrepreneurials(),
        this.getEntrepreneurialsType(),
        this.getEntrepreneurialsCountries(),
        this.getEntrepreneurialsCountriesArgentina()
      ]).then(() => {
        this.loading = false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
<style scoped>
.apexcharts-legend {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>